import { useState, useEffect } from "react";
import { 
  subscribeToUsers, 
  addUser,
  updateUser,
  deleteUser,
  resetUserPassword
} from "../services/userService";

export function useUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let unsubscribe = () => {};

    try {
      setLoading(true);
      unsubscribe = subscribeToUsers((data, err) => {
        if (err) {
          setError("Failed to load users.");
          setLoading(false);
          return;
        }
        setUsers(data);
        setLoading(false);
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize users subscription.");
      setLoading(false);
    }

    return () => unsubscribe();
  }, []);

  const handleAddUser = async (userData) => {
    try {
      setError("");
      return await addUser(userData);
    } catch (err) {
      console.error("Error adding user:", err);
      setError(err.message || "Failed to add user.");
      throw err;
    }
  };

  const handleUpdateUser = async (id, userData) => {
    try {
      setError("");
      await updateUser(id, userData);
    } catch (err) {
      console.error("Error updating user:", err);
      setError(err.message || "Failed to update user.");
      throw err;
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      setError("");
      await deleteUser(id);
    } catch (err) {
      console.error("Error deleting user:", err);
      setError(err.message || "Failed to delete user.");
      throw err;
    }
  };

  return {
    users,
    loading,
    error,
    setError,
    addUser: handleAddUser,
    updateUser: handleUpdateUser,
    deleteUser: handleDeleteUser,
    resetPassword: resetUserPassword
  };
}
